var $efe95218d340c8fc$exports = {};
$efe95218d340c8fc$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{435}\u{434}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`
};


export {$efe95218d340c8fc$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
